import Vue from "vue";
const ymid = window._ymid;
const ym = window.ym;
const dataLayer = window.dataLayer;

const isDev = process.env.NODE_ENV === "development";

function ymReachGoal(target, params) {
  ym(ymid, "reachGoal", target, params);
}

function pushInteraction(dataLayerPushOptions = {}) {
  if (!dataLayer) {
    console.warn("dataLayer was not found!");
    return;
  }
  dataLayer.push({
    event: "gaIntEvent",
    eventCategory: "Interactions",
    ...dataLayerPushOptions
  });
}

const events = {
  "download-map": () => ymReachGoal("click-download-map"),
  "how-to-play": () => ymReachGoal("click-how-to-play"),
  "click-tournament-details": () => {
    ymReachGoal("click-details-tournament-item-home");
    pushInteraction({
      eventAction: "Подробнее",
      eventLabel: "Tournaments"
    });
  },
  "click-wildcard-details": () => {
    ymReachGoal("click-wildcard-details");
    pushInteraction({
      eventAction: "Подробнее",
      eventLabel: "Wildcards"
    });
  },
  signin: () => {
    ymReachGoal("click-sign-in");
    pushInteraction({
      eventAction: "Sign In"
    });
  },
  "click-signin-inside-modal": () => {
    pushInteraction({
      eventAction: "Авторизоваться"
    });
  },
  "click-tournament-participate": () => {
    pushInteraction({
      eventAction: "Принять участие"
    });
  }
};

export default Vue.extend({
  methods: {
    metrics(eventName) {
      if (isDev) return;
      const event = events[eventName];
      if (event) event();
    }
  }
});
